import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import Layout from './components/Layout';
import { API_BASE_URL } from '../config/ApiConfig';
import { useNavigate } from 'react-router-dom';
import TableContainer from './components/TableContainer';
import Pagination10 from './components/Pagination10';
import useDefaultModal from './components/hooks/useDefaultModal';
import useConfirmModal from './components/hooks/useConfirmModal';
import ConfirmModal from './components/modals/ConfirmModal';
import DefaultModal from './components/modals/DefaultModal';
import ResponsiveShadow from './components/ResponsiveShadow';
import usePagination10 from './components/hooks/usePagination10';
import PageHeader from './components/PageHeader';
import PageContent from './components/PageContent';
import ContratoModal from './components/modals/ContratoModal';
import ContratoItensModal from './components/modals/ContratoItensModal';
import ContratoPedidosModal from './components/modals/ContratoPedidosModal';
import DataTable from './components/DataTable';

function Contratos() {
    const user = JSON.parse(localStorage.getItem('user'));
  const [contratos, setContratos] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [atualizar, setAtualizar] = useState(false);
  const [contratoSelecionado, setContratoSelecionado] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [possuiItens, setPossuiItens] = useState(false);
  const [contratoStats, setContratoStats] = useState({});
  const [contratoStatus, setContratoStatus] = useState({});
  const [selectedStatus, setSelectedStatus] = useState('');
  const location = useLocation();
  const selectStatusRef = useRef(null);
  const [highlight, setHighlight] = useState(false);
  const token = localStorage.getItem('token');
  const ano = localStorage.getItem('anoBase');
  const [isLoading, setLoading] = useState(true);
  const [tableMaxHeight, setTableMaxHeight] = useState('calc(100vh - 130px)');
  const clampLines = 3; // ajustar se quiser mostrar mais/menos linhas no Objeto
  const [modalItensAberto, setModalItensAberto] = useState(false);
  const [modalContratoPedidosAberto, setModalContratoPedidosAberto] = useState(false);
  const [contratoPedidoSelecionado, setContratoPedidoSelecionado] = useState(null);
  const navigate = useNavigate();
  const vinculo = JSON.parse(localStorage.getItem('vinculo'));
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { setConfirmModal, showConfirmModal } = useConfirmModal();
  const saldoPollRef = useRef(null);

  // ...existing code...

  useEffect(() => {
    if (!token) {
      navigate('/');
      return;
    }
    if (!vinculo || !vinculo.idEntidade) {
      showDefaultModal('error', 'Selecione uma entidade antes de acessar esta página.');
      window.location.href = '/home';
      return;
    }

    setLoading(true);
    // Aplicar filtro vindo de query params (ex: clique no card do dashboard)
    try {
      const params = new URLSearchParams(location.search);
      if (params.has('status')) {
        const s = params.get('status') || '';
        setSelectedStatus(s);
        setHighlight(true);
        setTimeout(() => {
          try { selectStatusRef.current && selectStatusRef.current.focus(); } catch (e) {}
        }, 120);
        setTimeout(() => setHighlight(false), 900);
        try { window.history.replaceState({}, document.title, window.location.pathname); } catch (e) {}
      }
    } catch (e) {}
    axios
      .get(`${API_BASE_URL.CONTRATO}/all`,
        { params: { idEntidade: vinculo.idEntidade, anoBase: ano },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(result => {
        setContratos(result.data);
        // Carregar estatísticas para cada contrato
        carregarEstatisticas(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter contratos:', error);
        showDefaultModal('error', 'Erro ao carregar contratos.');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [atualizar]);

  useEffect(() => {
    return () => {
      if (saldoPollRef.current) {
        clearInterval(saldoPollRef.current);
        saldoPollRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    function computeTableMaxHeight() {
      try {
        const header = document.querySelector('.navbar');
        const footer = document.querySelector('footer.footer') || document.querySelector('footer');
        const headerBottom = header ? header.getBoundingClientRect().bottom : 80;
        const footerTop = footer ? footer.getBoundingClientRect().top : window.innerHeight - 40;
        const available = Math.floor(footerTop - headerBottom - 40); // margem interna
        setTableMaxHeight(`${Math.max(200, available)}px`);
      } catch (e) {
        setTableMaxHeight('calc(100vh - 130px)');
      }
    }

    computeTableMaxHeight();
    window.addEventListener('resize', computeTableMaxHeight);
    const mo = new MutationObserver(computeTableMaxHeight);
    mo.observe(document.body, { childList: true, subtree: true, attributes: true });
    return () => {
      window.removeEventListener('resize', computeTableMaxHeight);
      mo.disconnect();
    };
  }, []);

  function carregarEstatisticas(contratosLista) {
    // Solicita estatísticas consolidadas em uma única chamada para reduzir carga de rede
    const reqStats = axios.get(`${API_BASE_URL.CONTRATO}/stats`, {
      params: { idEntidade: vinculo.idEntidade, anoBase: ano },
      headers: { Authorization: `Bearer ${token}` },
    });
    const reqStatus = axios.get(`${API_BASE_URL.CONTRATO}/status`, {
      params: { idEntidade: vinculo.idEntidade, anoBase: ano },
      headers: { Authorization: `Bearer ${token}` },
    });

    Promise.all([reqStats, reqStatus])
      .then(([resStats, resStatus]) => {
        setContratoStats(resStats.data || {});
        setContratoStatus(resStatus.data || {});
      })
      .catch(err => {
        console.error('Erro ao carregar estatísticas ou status consolidados:', err);
        setContratoStats({});
        setContratoStatus({});
      });
  }

  function handleDelete(contrato) {
    showConfirmModal('delete', () => handleConfirmDelete(contrato));
  }

  function handleConfirmDelete(contrato) {
    axios
      .delete(`${API_BASE_URL.CONTRATO}/${contrato.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        showDefaultModal('success', 'Contrato excluído com sucesso!');
        setAtualizar(prev => !prev);
      })
      .catch(error => {
        console.error('Erro ao excluir contrato:', error);
        showDefaultModal('error', 'Erro ao excluir o contrato!');
      });
  }

  function handleEdit(contrato) {
    setContratoSelecionado(contrato);
    setShowModal(true);
  }

  function handleNew() {
    setContratoSelecionado(null);
    setShowModal(true);
  }

  function handleCloseModal() {
    setShowModal(false);
    setContratoSelecionado(null);
  }

  function handleSaveSuccess() {
    setAtualizar(prev => !prev);
    setContratoSelecionado(null);
  }

  const importInputRef = useRef(null);
  const importFullJsonInputRef = useRef(null);


  async function handleImportFullJson(e) {
    const file = e.target.files[0];
    if (!importFullJsonInputRef.current) return;
    importFullJsonInputRef.current.value = '';
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async event => {
      let data;
      try {
        data = JSON.parse(event.target.result);
      } catch {
        showDefaultModal('error', 'Arquivo JSON inválido.');
        return;
      }

      if (!Array.isArray(data) || data.length === 0) {
        showDefaultModal('error', 'O JSON deve ser um array não vazio.');
        return;
      }

      const parseDateDMY = (dateStr) => {
        if (!dateStr) return '';
        const parts = dateStr.split('/');
        if (parts.length === 3) {
          const [d, m, y] = parts;
          return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
        }
        return dateStr;
      };

      setLoading(true);
      let totalItens = 0, totalPedidos = 0, erroItens = 0, erroPedidos = 0;
      const contratosNaoEncontrados = [];
      for (const bloco of data) {
        // 1. Encontrar contrato pelo numContrato: extrai o ano do numContrato (ex: "001/2024" → "2024")
        //    e usa o endpoint /all para buscar contratos da entidade naquele ano
        let contratoId = null;
        const numContrato = bloco.contrato?.numContrato;
        const partes = (numContrato || '').split('/');
        const anoContrato = partes.length >= 2 ? partes[partes.length - 1].replace(/\D/g, '').trim() : ano;
        const numPart = partes[0].trim(); // ex: "041" de "041/2025 - A"
        try {
          const res = await axios.get(`${API_BASE_URL.CONTRATO}/all`, {
            params: { idEntidade: vinculo.idEntidade, anoBase: anoContrato },
            headers: { Authorization: `Bearer ${token}` },
          });
          const encontrado = (res.data || []).find(c =>
            c.numContrato === numContrato ||
            (c.numContrato === numPart && String(c.ano) === String(anoContrato)) ||
            (c.numContrato === `${numPart}/${anoContrato}`)
          );
          contratoId = encontrado?.id ?? null;
          if (!contratoId) {
            console.warn('[ImportFullJson] Contrato não encontrado no find. numContrato JSON:', numContrato,
              '| numPart:', numPart, '| anoContrato:', anoContrato,
              '| Valores retornados pela API:', (res.data || []).map(c => `${c.numContrato}/${c.ano}`).slice(0, 5));
          }
        } catch (err) {
          console.error('[ImportFullJson] Erro ao buscar contrato:', numContrato, err?.message);
        }
        if (!contratoId) {
          contratosNaoEncontrados.push(numContrato);
          continue;
        }
        // 2. Importar itens
        if (Array.isArray(bloco.itens)) {
          for (const item of bloco.itens) {
            const itemPayload = {
              id: item.id,
              idContrato: contratoId,
              descricao: item.descricao,
              marca: item.marca,
              unidade: item.unidade,
              quantidade: item.quantidade,
              valorUnit: item.valorUnit,
            };
            try {
              await axios.post(API_BASE_URL.CONTRATO_ITEM, itemPayload, { headers: { Authorization: `Bearer ${token}` } });
              totalItens++;
            } catch {
              erroItens++;
            }
          }
        }
        // 3. Importar pedidos
        if (Array.isArray(bloco.pedidos)) {
          for (const pedidoObj of bloco.pedidos) {
            const pedido = pedidoObj.pedido;
            try {
              const pedidoPayload = {
                id: pedido.id,
                idContrato: contratoId,
                data: parseDateDMY(pedido.data),
              };
              const pedidoResp = await axios.post(API_BASE_URL.CONTRATO_PEDIDO, pedidoPayload, {
                headers: { Authorization: `Bearer ${token}` },
              });
              const pedidoId = pedidoResp.data?.id || pedido.id;
              if (Array.isArray(pedidoObj.itens)) {
                for (const i of pedidoObj.itens) {
                  const itemPayload = {
                    idContrato: contratoId,
                    idContratoPedido: pedidoId,
                    idContratoItem: i.idContratoItem,
                    qtdeAcumAnterior: i.qtdeAcumAnterior,
                    qtdePedida: i.qtdePedida,
                    qtdeAcumAtual: i.qtdeAcumAtual,
                    statusItem: i.statusItem || 'PENDENTE',
                  };
                  await axios.post(API_BASE_URL.CONTRATO_PEDIDO_ITEM, itemPayload, {
                    headers: { Authorization: `Bearer ${token}` },
                  });
                }
              }
              totalPedidos++;
            } catch (err) {
              console.error('[ImportFullJson] Erro ao importar pedido:', err?.response?.status, err?.response?.data);
              erroPedidos++;
            }
          }
        }
      }
      setLoading(false);
      setAtualizar(prev => !prev);
      let msg = `${totalItens} item(ns) e ${totalPedidos} pedido(s) importados com sucesso.`;
      if (erroItens || erroPedidos) msg += ` ${erroItens} erro(s) em itens, ${erroPedidos} erro(s) em pedidos.`;
      if (contratosNaoEncontrados.length > 0) {
        msg += ` Contratos não encontrados (${contratosNaoEncontrados.length}): ${contratosNaoEncontrados.join(', ')}.`;
      }
      const temErro = erroItens > 0 || erroPedidos > 0 || contratosNaoEncontrados.length > 0;
      showDefaultModal(temErro ? 'error' : 'success', msg);
    };
    reader.readAsText(file);
  }

  // Importa apenas contratos (já existente)
  function handleImportJson(e) {
    const file = e.target.files[0];
    if (!importInputRef.current) return;
    importInputRef.current.value = '';
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async event => {
      let data;
      try {
        data = JSON.parse(event.target.result);
      } catch {
        showDefaultModal('error', 'Arquivo JSON inválido.');
        return;
      }

      if (!Array.isArray(data) || data.length === 0) {
        showDefaultModal('error', 'O JSON deve ser um array não vazio.');
        return;
      }

      const user = JSON.parse(localStorage.getItem('user'));

      const parseDateDMY = str => {
        if (!str) return '';
        const parts = str.split('/');
        if (parts.length === 3) {
          const [d, m, y] = parts;
          return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
        }
        return str;
      };

      setLoading(true);
      let successCount = 0;
      let errorCount = 0;

      for (const item of data) {
        const ano = item.numContrato?.split('/')?.[1]
          ? parseInt(item.numContrato.split('/')[1])
          : new Date().getFullYear();

        const payload = {
          numContrato: item.numContrato || '',
          ano,
          idFornecedor: item.idFornecedor || '',
          numProcesso: item.numProcesso || '',
          nomeModalidade: item.nomeModalidade || '',
          numModalidade: item.numModalidade || '',
          dataInicio: parseDateDMY(item.dataInicio),
          dataFim: parseDateDMY(item.dataFim),
          dataRescisao: '',
          objeto: item.objeto || '',
          idEntidade: vinculo.idEntidade,
          usuario: user?.login || '',
        };

        try {
          await axios.post(API_BASE_URL.CONTRATO, payload, {
            headers: { Authorization: `Bearer ${token}` },
          });
          successCount++;
        } catch {
          errorCount++;
        }
      }

      setLoading(false);
      setAtualizar(prev => !prev);

      if (errorCount === 0) {
        showDefaultModal('success', `${successCount} contrato(s) importado(s) com sucesso!`);
      } else {
        showDefaultModal('error', `${successCount} importado(s) com sucesso, ${errorCount} com erro.`);
      }
    };
    reader.readAsText(file);
  }

  function verificarItens(idContrato) {
    axios
      .get(`${API_BASE_URL.CONTRATO_ITEM}/contrato/${idContrato}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(result => {
        setPossuiItens(result.data.length > 0);
      })
      .catch(error => {
        console.error('Erro ao verificar itens:', error);
        setPossuiItens(false);
      });
  }

  function handleSaldo(contrato) {
    if (!contrato) return;
    if (saldoPollRef.current) {
      clearInterval(saldoPollRef.current);
      saldoPollRef.current = null;
    }
    setLoading(true);
    axios
      .get(`${API_BASE_URL.CONTRATO}/saldoPedidosPdf/${contrato.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        const { jobId } = res.data || {};
        if (!jobId) {
          throw new Error('Sem jobId na resposta');
        }
        pollSaldo(jobId, contrato);
      })
      .catch(err => {
        console.error('Erro ao gerar saldo:', err);
        setLoading(false);
        showDefaultModal('error', 'Erro ao gerar relatório de saldo.');
      });
  }

  function pollSaldo(jobId, contrato) {
    const poll = () => {
      axios
        .get(`${API_BASE_URL.CONTRATO}/saldoPedidosPdfStatus/${jobId}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(res => {
          const { status, message } = res.data || {};
          if (status === 'PRONTO') {
            stopSaldoPoll();
            fetchSaldoFile(jobId, contrato);
          } else if (status === 'ERRO' || status === 'CHEIO') {
            stopSaldoPoll();
            setLoading(false);
            showDefaultModal('error', message || 'Erro ao gerar relatório de saldo.');
          }
        })
        .catch(err => {
          stopSaldoPoll();
          console.error('Erro ao verificar status do relatório:', err);
          setLoading(false);
          showDefaultModal('error', 'Erro ao verificar status do relatório.');
        });
    };
    stopSaldoPoll();
    poll();
    saldoPollRef.current = setInterval(poll, 2000);
  }

  function stopSaldoPoll() {
    if (saldoPollRef.current) {
      clearInterval(saldoPollRef.current);
      saldoPollRef.current = null;
    }
  }

  function fetchSaldoFile(jobId, contrato) {
    axios
      .get(`${API_BASE_URL.CONTRATO}/saldoPedidosPdfFile/${jobId}`, {
        responseType: 'blob',
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        setLoading(false);
        if (!res.data || res.data.size === 0) {
          throw new Error('PDF vazio');
        }
        const blob = new Blob([res.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const pdfId = `saldo_${contrato.id}_${Date.now()}`;

        if (!window.pdfStorage) {
          window.pdfStorage = {};
        }
        window.pdfStorage[pdfId] = blob;

        sessionStorage.setItem(
          'pdfViewerData',
          JSON.stringify({ url, title: `Saldo - Contrato ${contrato.numContrato}`, pdfId })
        );

        window.dispatchEvent(new CustomEvent('pdfViewerUpdate', { detail: { pdfId } }));
      })
      .catch(err => {
        setLoading(false);
        console.error('Erro ao baixar o relatório:', err);
        showDefaultModal('error', 'Erro ao baixar o relatório gerado.');
      });
  }

  const normalizeString = str => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  };

  const formatDate = iso => {
    if (!iso) return '-';
    try {
      const d = new Date(iso);
      return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
    } catch {
      return '-';
    }
  };

  // Apenas filtro de busca textual, contratos já vêm filtrados por entidade e ano da API

  // Filtra e ordena os contratos do maior para o menor (decrescente)
  // Função para normalizar números de contrato removendo tudo exceto dígitos
  const normalizeNumber = str => (str || '').replace(/\D/g, '');

  const contratosFiltrados = Array.isArray(contratos)
    ? contratos
        .filter(c => {
          const normalizedBusca = normalizeString(filtro);
          const normalizedBuscaNum = normalizeNumber(filtro);
          // filtro por status selecionado
          const st = contratoStatus[c.id];
          if (selectedStatus) {
            if (selectedStatus === 'VENCE') {
              if (!(st && typeof st === 'string' && st.startsWith('VENCE_EM_'))) return false;
            } else if (selectedStatus === 'ATIVO') {
              // ATIVO = não ENCERRADO e não VENCE_EM_*
              if (st && (st === 'ENCERRADO' || (typeof st === 'string' && st.startsWith('VENCE_EM_')))) return false;
            } else {
              if (st !== selectedStatus) return false;
            }
          }
          return (
            normalizeString(c.numContrato || '').includes(normalizedBusca) ||
            (normalizedBuscaNum && normalizeNumber(c.numContrato).includes(normalizedBuscaNum)) ||
            normalizeString(c.objeto || '').includes(normalizedBusca) ||
            normalizeString(c.fornecedor?.nome || '').includes(normalizedBusca) ||
            normalizeString(c.numProcesso || '').includes(normalizedBusca) ||
            normalizeString(c.ano?.toString() || '').includes(normalizedBusca)
          );
        })
        .sort((a, b) => {
          // Ordenação decrescente pelo campo numContrato (tratado como string)
          if (!a.numContrato && !b.numContrato) return 0;
          if (!a.numContrato) return 1;
          if (!b.numContrato) return -1;
          // Para garantir ordem decrescente, inverter a comparação
          return b.numContrato.localeCompare(a.numContrato, 'pt-BR', { numeric: true });
        })
    : [];

  const totalItems = contratosFiltrados.length;
  const { setPagination } = usePagination10(totalItems);
  const paginationRef = useRef();
  paginationRef.current = setPagination;
  const currentItems = contratosFiltrados.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  useEffect(() => {
    if (paginationRef.current && paginationRef.current.resetPage) {
      paginationRef.current.resetPage();
    }
  }, [filtro, selectedStatus]);

  

  return (
    <Layout>
      <ResponsiveShadow>
        <PageHeader title="Contratos" icon="bi-file-earmark-text" />
        <PageContent>
          <div className="d-flex flex-column flex-lg-row justify-content-lg-between gap-2 mb-2 align-items-start align-items-lg-center">
            <div className="botao-grid-2col">
              <button
                className="btn btn-success btn-sm botao-igual"
                onClick={handleNew}
                title="Cadastrar novo contrato"
              >
                <i className="bi bi-plus-circle me-1"></i>
                Novo
              </button>
              <button
                className="btn btn-primary btn-sm botao-igual"
                disabled={!contratoSelecionado}
                onClick={() => handleEdit(contratoSelecionado)}
                title="Editar contrato selecionado"
              >
                <i className="bi bi-pencil me-1"></i>
                Editar
              </button>
              <button
                className="btn btn-danger btn-sm botao-igual"
                disabled={!contratoSelecionado}
                onClick={() => handleDelete(contratoSelecionado)}
                title="Excluir contrato selecionado"
              >
                <i className="bi bi-trash me-1"></i>
                Excluir
              </button>
              <div className="toolbar-separator" />
              <button
                className="btn btn-info btn-sm text-white botao-igual"
                disabled={!contratoSelecionado}
                onClick={() => setModalItensAberto(true)}
                title={contratoSelecionado?.possuiAditivo ? "Visualizar itens (edição apenas no aditivo)" : "Ver itens do contrato selecionado"}
              >
                <i className="bi bi-list-ul me-1"></i>
                Itens
              </button>
              <button
                className="btn btn-warning btn-sm text-white botao-igual"
                disabled={!contratoSelecionado || !possuiItens}
                onClick={() => { setContratoPedidoSelecionado(contratoSelecionado); setModalContratoPedidosAberto(true); }}
                title={contratoSelecionado?.possuiAditivo ? "Visualizar pedidos (registro apenas no aditivo)" : (!possuiItens && contratoSelecionado ? "O contrato precisa ter itens cadastrados" : "Ver pedidos do contrato selecionado")}
              >
                <i className="bi bi-cart3 me-1"></i>
                Pedidos
              </button>
              <button
                className="btn btn-outline-primary btn-sm botao-igual"
                disabled={!contratoSelecionado}
                onClick={() => handleSaldo(contratoSelecionado)}
                title="Gerar relatório de saldo de pedidos"
              >
                <i className="bi bi-file-earmark-text me-1"></i>
                Saldo Pedidos
              </button>
              {user?.role === 'ADMIN' && (
                <>
                  <div className="btn-group">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm dropdown-toggle botao-igual"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      title="Importar"
                    >
                      <i className="bi bi-upload me-1"></i>
                      Importar
                    </button>
                    <ul className="dropdown-menu">
                      <li>
                        <button className="dropdown-item" type="button" onClick={() => importInputRef.current?.click()}>
                          Importar JSON
                        </button>
                      </li>
                      <li>
                        <button className="dropdown-item" type="button" onClick={() => importFullJsonInputRef.current?.click()}>
                          Importar JSON Completo
                        </button>
                      </li>
                    </ul>
                  </div>
                  <input
                    ref={importInputRef}
                    type="file"
                    accept=".json,application/json"
                    style={{ display: 'none' }}
                    onChange={handleImportJson}
                  />
                  <input
                    ref={importFullJsonInputRef}
                    type="file"
                    accept=".json,application/json"
                    style={{ display: 'none' }}
                    onChange={handleImportFullJson}
                  />
                </>
              )}
            </div>
            <div className="d-flex align-items-center gap-2 mt-2 mt-lg-0">
              <div className="input-group input-group-sm" style={{ transition: 'box-shadow 0.35s ease', boxShadow: highlight ? '0 0 0 6px rgba(13,110,253,0.18)' : 'none' }}>
                <span className="input-group-text d-flex align-items-center justify-content-center">
                  <i className="bi bi-filter"></i>
                </span>
                <select
                  className="form-select form-select-sm"
                  style={{ width: '100px' }}
                  ref={selectStatusRef}
                  value={selectedStatus}
                  onChange={e => setSelectedStatus(e.target.value)}
                  title="Filtrar por status"
                >
                  <option value="">Todos</option>
                  <option value="ATIVO">Ativo</option>
                  <option value="ENCERRADO">Encerrado</option>
                  <option value="VENCE">Vence em...</option>
                </select>
              </div>
              <div className="input-group input-group-sm">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Buscar..."
                  title="Buscar por número, objeto, fornecedor, processo ou ano"
                  value={filtro}
                  onChange={e => setFiltro(e.target.value.toUpperCase())}
                />
              </div>
            </div>
          </div>

          <TableContainer isLoading={isLoading}>
                <DataTable style={{ fontSize: '0.8rem' }} head={<tr>
                  <th scope="col" className="px-2">Número</th>
                  <th scope="col" className="px-2">Fornecedor</th>
                  <th scope="col" className="px-2">Objeto</th>
                  <th scope="col" className="px-2" style={{ minWidth: '180px' }}>Vigência</th>
                  <th scope="col" className="px-2 text-center">Status</th>
                  <th scope="col" className="px-2 text-center">Itens</th>
                  <th scope="col" className="px-2 text-center">Pedidos</th>
                </tr>}>
              <tbody>
                {currentItems.length === 0 && (
                  <tr>
                    <td colSpan={7} className="text-center text-muted py-3">
                      <i className="bi bi-inbox fs-3 d-block mb-2"></i>
                      Nenhum contrato encontrado
                    </td>
                  </tr>
                )}
                {currentItems.map(contrato => (
                  <tr
                    key={contrato.id}
                    className={
                      contratoSelecionado &&
                      contratoSelecionado.id === contrato.id
                        ? 'table-primary'
                        : ''
                    }
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      if (
                        contratoSelecionado &&
                        contratoSelecionado.id === contrato.id
                      ) {
                        setContratoSelecionado(null);
                        setPossuiItens(false);
                      } else {
                        setContratoSelecionado(contrato);
                        verificarItens(contrato.id);
                      }
                    }}
                  >
                    <td className="px-2">
                      {contrato.numContrato}
                      {contrato.tipoCadastro === 'ADITIVO' && (
                        <span className="badge bg-info text-dark ms-1" style={{ fontSize: '0.65rem' }}>
                          ADITIVO
                        </span>
                      )}
                    </td>
                    {/* coluna ano removida */}
                    <td className="px-2">{contrato.fornecedor?.nome || '-'}</td>
                    <td className="px-2">
                      <div style={{ display: '-webkit-box', WebkitLineClamp: clampLines, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                        {contrato.objeto || '-'}
                      </div>
                    </td>
                        <td className="px-2" style={{ minWidth: '180px' }}>
                          {formatDate(contrato.dataInicio)} - {formatDate(contrato.dataFim)}
                        </td>
                      <td className="px-2 text-center">
                      {(() => {
                        const st = contratoStatus[contrato.id];
                        if (!st) return <span className="badge bg-secondary">...</span>;
                        if (st === 'ENCERRADO') return <span className="badge bg-danger">Encerrado</span>;
                        if (st && st.startsWith('VENCE_EM_')) {
                          const m = st.match(/VENCE_EM_(\d+)_DIAS/);
                          const dias = m ? Number(m[1]) : NaN;
                          if (!isNaN(dias)) {
                            if (dias === 0) return <span className="badge bg-warning text-dark">Vence hoje</span>;
                            if (dias === 1) return <span className="badge bg-warning text-dark">Vence amanhã</span>;
                            return <span className="badge bg-warning text-dark">Vence em {dias} dias</span>;
                          }
                          return <span className="badge bg-warning text-dark">Vence em ? dias</span>;
                        }
                        return <span className="badge bg-success">Ativo</span>;
                      })()}
                    </td>
                    <td className="px-2 text-center">
                      <span className="badge bg-info">
                        {contratoStats[contrato.id]?.itens || 0}
                      </span>
                    </td>
                    <td className="px-2 text-center">
                      <span className="badge bg-warning">
                        {contratoStats[contrato.id]?.pedidos || 0}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
              </DataTable>
            </TableContainer>
        </PageContent>
        <div style={{ padding: '0.5rem 1rem', borderTop: '1px solid rgba(0,0,0,0.1)', backgroundColor: '#f8f9fa' }}>
          <Pagination10 {...setPagination} />
        </div>
        <ConfirmModal {...setConfirmModal} />
        <DefaultModal {...setDefaultModal} />
        <ContratoItensModal isOpen={modalItensAberto} onClose={() => setModalItensAberto(false)} contrato={contratoSelecionado} possuiAditivo={contratoSelecionado?.possuiAditivo} onSave={() => setAtualizar(prev => !prev)} />
        <ContratoPedidosModal isOpen={modalContratoPedidosAberto} onClose={() => { setModalContratoPedidosAberto(false); setAtualizar(prev => !prev); }} contrato={contratoPedidoSelecionado} possuiAditivo={contratoPedidoSelecionado?.possuiAditivo} />
      </ResponsiveShadow>

      {showModal && (
        <ContratoModal
          show={showModal}
          contrato={contratoSelecionado}
          onClose={handleCloseModal}
          onSave={async (formData) => {
            try {
              const payload = !contratoSelecionado
                ? { ...formData, idEntidade: vinculo.idEntidade, usuario: user?.login || '' }
                : { ...formData, id: contratoSelecionado.id, idEntidade: vinculo.idEntidade };
              let res;
              if (!contratoSelecionado) {
                res = await axios.post(`${API_BASE_URL.CONTRATO}`, payload, { headers: { Authorization: `Bearer ${token}` } });
              } else {
                res = await axios.put(`${API_BASE_URL.CONTRATO}/${contratoSelecionado.id}`, payload, { headers: { Authorization: `Bearer ${token}` } });
              }
              setAtualizar(prev => !prev);
              return Promise.resolve(res.data);
            } catch (e) {
              return Promise.reject(e);
            }
          }}
        />
      )}
    </Layout>
  );
}

export default Contratos;
